import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseAPIService } from '../base.service'

@Injectable({
  providedIn: 'root'
})

export class ExaminadorEstabelecimentoService extends BaseAPIService  {
  
  constructor(protected http:HttpClient) { 
    super('exame/examinadorestabelecimento/');
    
  }
}
